export default __webpack_public_path__ + "static/18-min-d7ed549a9ccd50fcd6f9e8819597d50a.png";